<script lang="ts">
  import { getContext } from "svelte"
  import IntegrationTypes from "website_script/constants/IntegrationTypes"
  import AUButton from "component_library/components/svelte/ui/AUButton.svelte"
  import themeTokens from "conversion_flows/theme/LibUIThemeTokens"
  import type { DealerTheme } from "conversion_flows/shared/contexts/dealerTheme"
  import Svg from "website_script/components/Svg.svelte"
  import type { PromptConfig, Settings } from "website_script/types/settings"
  import type { ButtonConfig } from "website_script/types/widgets"
  import LPNForm from "component_library/components/svelte/LPNForm.svelte"
  import type AUPopover from "component_library/components/svelte/ui/AUPopover.svelte"
  import { leadFlowIcon } from "conversion_flows/types/leadFlowIcons"
  import { getFlowsContext } from "website_script/contexts/flows"

  export let promptConfig: PromptConfig
  export let buttonConfig: ButtonConfig
  export let integrationType: IntegrationTypes
  export let popover: AUPopover

  const dealerTheme = getContext<DealerTheme>("dealerTheme")
  const { licensePlateCountry } = getContext<Settings>("settings")
  const { triggerFlow } = getFlowsContext()
  const tokens = themeTokens(dealerTheme)
</script>

{#if promptConfig.action === "cta"}
  <AUButton
    fullWidth
    onClick={() => {
      triggerFlow(buttonConfig, integrationType)
      popover.close()
    }}
  >
    <Svg
      color={String(tokens("colors.primaryContrastForeground"))}
      alt={promptConfig.cta_text}
      aria-hidden="true"
      slot="leftIcon"
      data={leadFlowIcon(promptConfig.icon)}
    />
    {promptConfig.cta_text}
  </AUButton>
{:else if promptConfig.action === "lpn_input" && licensePlateCountry}
  <LPNForm
    {licensePlateCountry}
    onSubmit={(licensePlateNumber) => {
      const urlData = licensePlateNumber ? { vin_lpn: licensePlateNumber } : {}

      triggerFlow(buttonConfig, integrationType, urlData)
      popover.close()
    }}
  />
{/if}
